export const TOOLTIP_ANCHOR = 'gmp-custom-tooltip-anchor';
export const TOOLTIP_ID = 'dynamic-tooltip';
